'use es6';

import TemplateTypes from 'ContentUtils/constants/TemplateTypes';
export const SIMPLE_LP_TEMPLATE_TYPE = TemplateTypes.byName.simple_landing_page_template.id;